import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LookAndFeelService {

    private lfnSubject = new BehaviorSubject<any>(null);

    get lnf$() {
        return this.lfnSubject.asObservable();
    }

    constructor() { }

    setLookAndFeel(lnf){
        this.lfnSubject.next(lnf);
    }
}
